import { observer } from 'mobx-react'
import React, { FC } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import ImageGallery from 'react-image-gallery'

interface IVendorImageGallery {
  model: any
  intl: any
  isMobile?: boolean | undefined
}

const VendorImageGallery: FC<IVendorImageGallery> = observer(({ model, intl, isMobile }) => {
  let vendorLocationsStr = ''
  model.vendorInfo.locations.forEach((location: any) => {
    vendorLocationsStr += intl.formatMessage({
      id: `locations.${location.translation_key}`,
      defaultMessage: location.name_default
    })
  })
  const altImgPart = ` - ${model.vendorInfo.mainName} - ${vendorLocationsStr}`
  const items = model.vendorInfo.carouselURLs.map((url: string) => ({ original: url, originalAlt: `Фото номер ${model.vendorInfo.carouselURLs.indexOf(url) + 1}${altImgPart}` }))

  if (isMobile) {
    return (
      <div className='vendor_images_container mobile w-100'>
        {model.isGalleryOpen
          ? <div onClick={() => model.setIsGalleryOpen(false)} className='close_btn d-flex align-items-center'></div>
          : <div className='w-100 show_more_btn_container w-100 d-flex align-items-center justify-content-center'>
              <div onClick={() => model.setIsGalleryOpen(true)} className='show_more_btn d-flex align-items-center gap-1'>
                <FormattedMessage id='vendors.gallery_show_all' defaultMessage='Show all' /> ({model.vendorInfo.carouselURLs.length})
              </div>
            </div>
        }
        {model.isGalleryOpen
          ? <ImageGallery useBrowserFullscreen items={items} />
          : <div className='vendor__page_image'>
            <div className='vendor_image d-flex justify-content-center'>
              <img alt={'Фото номер 1' + altImgPart} src={model.vendorInfo.carouselURLs[0]} />
            </div>
          </div>
        }
      </div>
    )
  } else {
    return (
      <div className='vendor_images_container w-100'>
        {model.isGalleryOpen
          ? <div onClick={() => model.setIsGalleryOpen(false)} className='close_btn d-flex align-items-center'></div>
          : <div onClick={() => model.setIsGalleryOpen(true)} className='show_more_btn d-flex align-items-center gap-1'>
              <FormattedMessage id='vendors.gallery_show_all' defaultMessage='Show all' /> ({model.vendorInfo.carouselURLs.length})
            </div>
        }
        {model.isGalleryOpen
          ? <ImageGallery useBrowserFullscreen items={items} />
          : <div className='vendor__page_images'>
            {model.vendorInfo.carouselURLs.slice(0, 6).map((url: string) =>
              (
                <img
                  key={url}
                  src={url}
                  alt={`Фото номер ${model.vendorInfo.carouselURLs.indexOf(url) + 1}` + altImgPart}
                  className={`vendor__image-grid vendor__image-grid_${model.vendorInfo.carouselURLs.indexOf(url) + 1}`}
                />
              )
            )}
          </div>
        }
      </div>
    )
  }
})

export default injectIntl(VendorImageGallery)
